import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=806bc584&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806bc584",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('806bc584')) {
      api.createRecord('806bc584', component.options)
    } else {
      api.reload('806bc584', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=806bc584&scoped=true&", function () {
      api.rerender('806bc584', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rpRBnaeS0D7f/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports